import React from 'react';
import CyberGridBackground from './CyberGridBackground';
import CyberReveal from './CyberReveal';
import RaidFvBootGate from './RaidFvBootGate';
import FirstView from './sections/FirstView';
import RaidIntro from './sections/RaidIntro';
import Benefits from './sections/Benefits';
import CompanyIntro from './sections/CompanyIntro';
import PeopleInterviews from './sections/PeopleInterviews';
import Recommended from './sections/Recommended';
import Overview from './sections/Overview';
import Eligibility from './sections/Eligibility';
import SelectionFlow from './sections/SelectionFlow';
import Notes from './sections/Notes';
import EntryForm from './sections/EntryForm';
import CompanyOverviewFooter from './sections/CompanyOverviewFooter';

// RAID サマーインターン2026 の独立 LP 本体。Header/Footer は付けない。
export default function RaidLanding() {
  return (
    <div className="relative isolate min-h-screen overflow-x-clip font-body text-white">
      <CyberGridBackground className="fixed inset-0 z-0" />
      <RaidFvBootGate>
        <main className="relative z-10 pb-14">
          <FirstView />
          <CyberReveal variant="line">
            <RaidIntro />
          </CyberReveal>
          <CyberReveal variant="scan">
            <Benefits />
          </CyberReveal>
          <CyberReveal variant="line">
            <CompanyIntro />
          </CyberReveal>
          <CyberReveal variant="line">
            <PeopleInterviews />
          </CyberReveal>
          <CyberReveal variant="scan">
            <Recommended />
          </CyberReveal>
          <CyberReveal variant="line">
            <Overview />
          </CyberReveal>
          <CyberReveal variant="scan">
            <Eligibility />
          </CyberReveal>
          <CyberReveal variant="line">
            <SelectionFlow />
          </CyberReveal>
          <CyberReveal variant="line">
            <Notes />
          </CyberReveal>
          <CyberReveal variant="scan">
            <EntryForm />
          </CyberReveal>
          <CyberReveal variant="line">
            <CompanyOverviewFooter />
          </CyberReveal>
        </main>
      </RaidFvBootGate>
    </div>
  );
}
